// 基准大小
const baseSize = 16;

// 设置 rem 函数
const setRem = () => {
  // 当前页面宽度相对于 1440 宽的缩放比例，可根据自己需要修改。
  // const scale = document.documentElement.clientWidth / 1440;
  const scale = document.documentElement.clientHeight / 781;
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
};

window.addEventListener("resize", () => {
  setRem();
});
window.addEventListener("DOMContentLoaded", () => {
  setRem();
});
window.addEventListener("load", () => {
  setRem();
});
